// import { useNavigate } from "react-router-dom";
// import NotificationBell from "../../modules/settings/notifications/NotificationBell";
// import defaultAvatar from "../../assets/images/avatar/employee-1.png";
// import logo from "../../assets/images/logo/logo-ima-hec.png";

// export default function MobileHeader({ user }) {
//   const navigate = useNavigate();
//   const avatarUrl = user?.avatar_url || defaultAvatar;

//   return (
//     <header className="flex items-center justify-between px-4 h-14 bg-white shadow sticky top-0 z-40">
//       {/* Logo */}
//       <div className="flex items-center">
//         <img
//           src={logo}
//           alt="IMA Logo"
//           className="h-7"
//           onClick={() => navigate("/m/home")}
//         />
//       </div>

//       {/* Bell + Avatar */}
//       <div className="flex items-center gap-4">

//         {/* 🔔 Chuông thông báo */}
//         <NotificationBell
//           onClick={() => navigate("/system/notifications")}
//         />

//         {/* Avatar */}
//         <img
//           src={avatarUrl}
//           alt="Avatar"
//         //   onClick={() => navigate("/m/profile")}
//           className="h-8 w-8 rounded-full border cursor-pointer"
//         />
//       </div>
//     </header>
//   );
// }







import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, Menu } from "lucide-react"; // Import thêm icon để giao diện đầy đủ hơn
import NotificationBell from "../../modules/settings/notifications/NotificationBell";
import FeedbackButton from "../../components/feedback/FeedbackButton";
import defaultAvatar from "../../assets/images/avatar/employee-1.png";
import logo from "../../assets/images/logo/logo-ima-hec.png";

export default function MobileHeader({ user }) {
  const navigate = useNavigate();
  const avatarUrl = user?.avatar_url || defaultAvatar;

  return (
    <header className="shrink-0 border-b border-gray-100 bg-white">
      <div className="flex h-14 items-center justify-between px-4 sm:h-16">
      {/* LEFT: Logo & Brand */}
      <div 
        className="flex items-center gap-2 active:scale-95 transition-transform"
        onClick={() => navigate("/m/home")}
      >
        <div className="p-1.5 bg-red-50 rounded-xl">
          <img
            src={logo}
            alt="IMA Logo"
            className="h-7 w-auto object-contain"
          />
        </div>
        {/* <div className="flex flex-col">
          <span className="text-xs font-black text-gray-800 uppercase tracking-tighter leading-none">
            IMA <span className="text-red-700">ERP</span>
          </span>
          <span className="text-[8px] text-gray-400 font-bold uppercase tracking-widest">
            Mobile Edition
          </span>
        </div> */}
      </div>

      {/* RIGHT: Actions */}
      <div className="flex items-center gap-2">
        {/* Search Icon (Thêm vào để Header cân đối hơn trên mobile) */}
        {/* <button className="p-2 text-gray-400 hover:text-red-700 active:bg-red-50 rounded-full transition-all">
          <Search size={20} />
        </button> */}

        <div className="relative p-1">
          <FeedbackButton />
        </div>

        {/* 🔔 Chuông thông báo */}
        <div className="relative p-1">
          <NotificationBell
            onClick={() => navigate("/system/notifications")}
          />
        </div>

        {/* Avatar với phong cách Rounded-XL đồng bộ hệ thống */}
        <motion.div 
          whileTap={{ scale: 0.9 }}
          onClick={() => navigate("/m/profile")}
          className="ml-1 p-0.5 rounded-xl border-2 border-white shadow-sm ring-1 ring-gray-100 overflow-hidden"
        >
          <img
            src={avatarUrl}
            alt="Avatar"
            className="h-8 w-8 rounded-[10px] object-cover"
          />
        </motion.div>
      </div>
      </div>
    </header>
  );
}